import { render, staticRenderFns } from "./postBeacon.vue?vue&type=template&id=2088d107&scoped=true&"
import script from "./postBeacon.vue?vue&type=script&lang=js&"
export * from "./postBeacon.vue?vue&type=script&lang=js&"
import style0 from "./postBeacon.vue?vue&type=style&index=0&id=2088d107&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2088d107",
  null
  
)

export default component.exports